var _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuReportFocus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5C3 9.11929 4.11929 8 5.5 8C6.88071 8 8 9.11929 8 10.5V17C8 17.5523 7.55228 18 7 18H4C3.44772 18 3 17.5523 3 17V10.5Z",
    fill: "#004FEC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#004FEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C10 6.11929 11.1193 5 12.5 5C13.8807 5 15 6.11929 15 7.5V17C15 17.5523 14.5523 18 14 18H11C10.4477 18 10 17.5523 10 17V7.5Z",
    fill: "#004FEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.5C17 2.11929 18.1193 1 19.5 1C20.8807 1 22 2.11929 22 3.5V17C22 17.5523 21.5523 18 21 18H18C17.4477 18 17 17.5523 17 17V3.5Z",
    fill: "#004FEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.5C17 2.11929 18.1193 1 19.5 1C20.8807 1 22 2.11929 22 3.5V17C22 17.5523 21.5523 18 21 18H18C17.4477 18 17 17.5523 17 17V3.5Z",
    fill: "#004FEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReportFocus);
export default __webpack_public_path__ + "static/media/menu_report_focus.4392204e604a08730791829cc22dddda.svg";
export { ForwardRef as ReactComponent };